<template>
    <ul v-if="step.checklist && step.checklist.length" class="m-accordion u-listUnstyled">
        <li 
            v-for="(checklist, index) in step.checklist" 
            :key="index" 
            class="m-accordion__item u-mb15 u-bgWhite u-br u-border u-pt20 u-px20"
        >
            <div 
                class="m-accordion__titleHolder u-pb20" 
                @click="toggleItems(index)"
            >
                <div class="m-accordion__title">
                    <h3 class="u-mb0">{{ checklist.checklist_title }}</h3>
                </div>
                <div class="m-accordion__right">
                    <div 
                        class="a-tag" 
                        :class="{ '-green': isChecklistComplete(index) }"
                    >
                        {{ getCompletionPercentage(index) }}%
                    </div>
                    <div class="a-iconButton -tiny -secondary">
                        <i :class="isOpen[index] ? 'bx bx-chevron-up' : 'bx bx-chevron-down'"></i>
                    </div>
                </div>
            </div>
            <ul
                v-show="isOpen[index]" 
                class="m-accordion__content u-pb20 u-px20 u-listUnstyled"
            >
                <li
                    v-for="(item, itemIndex) in checklist.checklist_items" 
                    :key="itemIndex" 
                    class="u-mb10"
                >
                    <div class="custom-checkbox">
                        <input 
                            :id="`item-${index}-${itemIndex}`" 
                            type="checkbox" 
                            v-model="checkedItems[index][itemIndex]"
                        >
                        <label :for="`item-${index}-${itemIndex}`">{{ item.title }}</label>
                    </div>
                </li>
            </ul>
        </li>
    </ul>
    <FixedButton 
        :isDisabled="!allChecklistsComplete" 
        @click="handleButtonClick" 
    >
        {{ $t('module.completeModule') }}
    </FixedButton>
</template>

<script setup>
import { ref, computed, watch, inject } from 'vue';
import { useI18n } from 'vue-i18n';

// Components
import FixedButton from './FixedButton.vue';

const props = defineProps({
    step: {
        type: Object,
        required: true
    },
});

const { t } = useI18n(); 
const answeredCorrect = ref(false);
const isOpen = ref([]);
const checkedItems = ref([]);
const showTryAgain = ref(false);

const completeStep = inject('completeStep');

watch(
    () => props.step.checklist,
    (newChecklist) => {
        if (newChecklist && newChecklist.length) {
            isOpen.value = Array(newChecklist.length).fill(false);
            checkedItems.value = newChecklist.map((checklist) =>
                checklist.checklist_items ? Array(checklist.checklist_items.length).fill(false) : []
            );
        }
    },
    { immediate: true }
);

const toggleItems = (index) => {
    isOpen.value[index] = !isOpen.value[index];
};

const getCompletionPercentage = (index) => {
    const checklist = checkedItems.value[index];
    if (!checklist || checklist.length === 0) return 0;
    const checkedCount = checklist.filter(item => item).length;
    return Math.round((checkedCount / checklist.length) * 100);
};

const isChecklistComplete = (index) => {
    return getCompletionPercentage(index) === 100;
};

const allChecklistsComplete = computed(() => {
    return checkedItems.value.every((checklist, index) => isChecklistComplete(index));
});

const handleButtonClick = () => {
    if(allChecklistsComplete.value == true) {
        completeStep(props.step.uuid, true, true);
    }
};
</script>
